<template>
<v-card v-resize="onResize" class="ma-2 pa-2" justify="between">
  <v-row justify="center">
    <v-col shrink class="px-1 mx-1 my-2 py-2">
      <h3 class="text-center">Filter by Time of Day</h3>
      <v-btn-toggle class="mx-2 px-2" color='' v-model="dayNightOption" mandatory @change="dayNightChange">
        <v-btn :value="0">Day</v-btn>
        <v-btn :value="1">Night</v-btn>
        <v-btn :value="2">Full</v-btn>
      </v-btn-toggle>
    <!-- </v-flex>
    <v-flex shrink> -->
      <v-btn-toggle class="mx-2 px-2" v-model="timesSelected" @change='toggleTimes' multiple style='box-shadow: 0 0 0 !important;'>
        <v-row wrap class="py-1 my-1" justify="center">
          <v-btn class="white--text primary" v-for="time in times" :key='time'>{{time}}</v-btn>
        </v-row>
      </v-btn-toggle>
    </v-col>
  </v-row>
  <v-row wrap class="justify-space-between">
    <v-col cols="12" class="">
      <v-row no-gutters wrap align="center" class="" align-content="center">
        <!-- <v-flex shrink align-self-center> -->
        <!-- <v-col cols="12" class="align-self-center justify-between" justify="between"> -->
          <v-toolbar flat width="100%" class="align-center">
            <v-toolbar-items class="align-center">
              <v-select solo elevation-1 filled class="ma-0 pa-0 mr-5 mt-5 title font-weight-regular text-center align-content-end" height="90%" background-color="white" v-model="weatherDataOption" :items="weatherDataOptionLabel" @change="weatherDataChange">
              </v-select>
              <v-spacer></v-spacer>
              <span class="title font-weight-bold align-center">Animation:</span>
              <v-btn class="mr-5 align-center" background-color='white' shrink v-model="dataLoopOption" text @click="dataLoopChange()"><v-icon>{{playPause}}</v-icon></v-btn>
              <v-btn-toggle class="ml-2 align-center" v-model="dataIntervalOption" @change="dataIntervalChange">
                <!-- <v-btn :value="0">Daily</v-btn> -->
                <v-btn>Weekly</v-btn>
                <v-btn>Monthly</v-btn>
              </v-btn-toggle>
            </v-toolbar-items>
          </v-toolbar>
        <!-- </v-col> -->
        <!-- </v-flex> -->
      </v-row>
      <v-row>
        <div ref='dataZoom' class='mt-0 pt-0' style='height:200px;width:100%'></div>
      </v-row>
      <v-row wrap>
        <v-col cols="12" class="my-1 py-2 text-center">
          <span class="headline">{{this.dateData[startDate]}}</span>
          <v-icon> arrow_forward </v-icon>
          <span class="headline">{{this.dateData[this.endDate]}}</span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</v-card>
</template>

<script>
  import shine from '@/components/plugins/echarts-theme-shine'
  import weatherData from '@/assets/weatherData.json';

  export default{
    data: () => ({
      looper: null,
      playPause: 'play_arrow',
      timeInterval: 700, //milliseconds
      dataIntervalOption: 2,
      dataInterval: 1, //1 day at a time
      dataZoom: null,
      weatherDataOption: 0,
      weatherDataOptionLabel: [{text:"Average Temperature (daily)",value:0},{text:"Cumulative Precipation (daily)",value:1},{text:"Specific Solar Energy (daily)",value:2},{text:"Average Wind Speed (daily)",value:3}],
      dayNightOption: 2,
      // times: ["00:00","01:00","02:00","03:00","04:00","05:00","06:00","07:00","08:00","09:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00","19:00","20:00","21:00","22:00","23:00"],
      times: ["00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23"],
      timesSelected: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
    }),
    methods: {
      displayMessage(msg){
        console.log(msg);
      },
      onResize() {
        if(this.dataZoom)_.debounce(this.dataZoom.resize,100)()
      },
      changeDataZoom(){
        console.log(this.dataZoom.getOption())
        this.$store.commit('changeDates',this.dataZoom.getOption());
      },
      dataIntervalChange(){
        this.stopLooping();
        let dataZoomOption = this.dataZoom.getOption();
        if(this.dataIntervalOption==0){
          // this.dataInterval=1;
          // this.timeInterval=600;
          dataZoomOption.dataZoom[0].startValue = this.startDate;
          dataZoomOption.dataZoom[0].start = (this.startDate)/this.dateData.length*100;
          dataZoomOption.dataZoom[0].endValue = this.startDate;
          dataZoomOption.dataZoom[0].end = (this.startDate)/this.dateData.length*100;
        }else if(this.dataIntervalOption==1){
          // this.dataInterval=7;
          // this.timeInterval=700;
          if(this.startDate+6<=this.dateData.length){
            dataZoomOption.dataZoom[0].startValue = this.startDate;
            dataZoomOption.dataZoom[0].start = (this.startDate)/this.dateData.length*100;
            dataZoomOption.dataZoom[0].endValue = this.startDate+6;
            dataZoomOption.dataZoom[0].end = (this.startDate+6)/this.dateData.length*100;
          }else{
            dataZoomOption.dataZoom[0].startValue = this.dateData.length-6;
            dataZoomOption.dataZoom[0].start = (this.dateData.length-6)/this.dateData.length*100;
            dataZoomOption.dataZoom[0].endValue = this.dateData.length;
            dataZoomOption.dataZoom[0].end = (this.dateData.length)/this.dateData.length*100;
          }
        }else if(this.dataIntervalOption==2){
          // this.dataInterval=30;
          // this.timeInterval=3000;
          if(this.startDate+6<=this.dateData.length){
            dataZoomOption.dataZoom[0].startValue = this.startDate;
            dataZoomOption.dataZoom[0].start = (this.startDate)/this.dateData.length*100;
            dataZoomOption.dataZoom[0].endValue = this.startDate+29;
            dataZoomOption.dataZoom[0].end = (this.startDate+30)/this.dateData.length*100;
          }else{
            dataZoomOption.dataZoom[0].startValue = this.dateData.length-30;
            dataZoomOption.dataZoom[0].start = (this.dateData.length-30)/this.dateData.length*100;
            dataZoomOption.dataZoom[0].endValue = this.dateData.length;
            dataZoomOption.dataZoom[0].end = (this.dateData.length)/this.dateData.length*100;
          }
        };
        this.dataZoom.setOption(dataZoomOption);
        this.changeDataZoom();
        if(this.playPause == "pause"){
          this.$store.commit('changeDataLoopOption');
          this.playPause = "play_arrow";
        }
      },
      dataLoopChange(){
        this.$store.commit('changeDataLoopOption');
        if(this.dataLoopOption==0){
            this.playPause = 'play_arrow';
            this.stopLooping();
        }else if(this.dataLoopOption==1){
            this.playPause = 'pause';
            this.startLooping();
          };
      },
      startLooping(){
        if(this.endDate-this.startDate == this.dateData.length){

        }else{
          this.looper = setInterval(()=>{
            let dataZoomOption = this.dataZoom.getOption();
            if(this.endDate<=(364-this.dataInterval)){
              dataZoomOption.dataZoom[0].startValue += this.dataInterval;
              dataZoomOption.dataZoom[0].start += (this.dataInterval)/this.dateData.length*100;
              dataZoomOption.dataZoom[0].endValue += this.dataInterval;
              dataZoomOption.dataZoom[0].end += (this.dataInterval)/this.dateData.length*100;
            }else{
              dataZoomOption.dataZoom[0].startValue = 0;
              dataZoomOption.dataZoom[0].start = 0;
              dataZoomOption.dataZoom[0].endValue = this.endDate-this.startDate;
              dataZoomOption.dataZoom[0].end = (this.endDate-this.startDate)/this.dateData.length*100;
            }
            this.dataZoom.setOption(dataZoomOption);
            this.changeDataZoom();
          },this.timeInterval);
        }
      },
      stopLooping(){
        clearInterval(this.looper);
      },
      dayNightChange(){
        console.log('dayNight: ' + this.dayNightOption)
        if(this.dayNightOption == 0){
          //daytime work/class hours
          this.timesSelected = [8,9,10,11,12,13,14,15,16,17,18];
        }else if(this.dayNightOption == 1){
          //nighttime no work/class
          this.timesSelected = [0,1,2,3,4,5,6,7,19,20,21,22,23];
        }else if(this.dayNightOption == 2){
          //full day
          this.timesSelected = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];
        }else{};
        this.changeTimes();
      },
      toggleTimes(){
        console.log('toggling times')
        // this.dayNightOption = 3;
        this.changeTimes();
        console.log(this.dayNightOption)
      },
      changeTimes(){
        console.log(this.timesSelected)
        this.$store.commit('changeTimes',this.timesSelected);
        this.refreshDataZoom;
      },
      weatherDataChange(){
        this.refreshDataZoom;
      }
    },
    watch: {
      baseYear(){
        this.refreshDataZoom;
      }
    },
    computed: {
      startDate(){
        return this.$store.state.startDateInd;
      },
      endDate(){
        return this.$store.state.endDateInd;
      },
      baseYear(){
        return this.$store.state.weather.baseYear;
      },
      dataLoopOption(){
        return this.$store.state.dataLoopOption;
      },
      getWeatherData: function() {
        return (weatherData)
      },
      filterData(){
        // let startIndex = this.dataZoom.getOption().dataZoom[0].startValue;
        // let endIndex = this.dataZoom.getOption().dataZoom[0].endValue;
        let filteredData = weatherData.filter(data => new Date(data.Time) >= new Date(this.dateData[this.$store.state.startDateInd])  && new Date(data.Time) <= new Date(this.dateData[this.$store.state.endDateInd]));
        filteredData = filteredData.filter(data => this.timesSelected.contains(new Date(data.Time).getHours()))
        return filteredData;
      },
      dateData(){
        let t0 = performance.now();
        let dateData = [...new Set(weatherData.map(({Time}) => {
          let date = new Date(Time);
          date.setFullYear(this.baseYear);
          return date.toLocaleDateString()
        }))];
        if(dateData[dateData.length-1]=='12/31/1969'){
          dateData.pop();
        }
        let t1 = performance.now();
        return dateData;
      },
      dayMonthData(){
        let t0 = performance.now();
        let dates = [...this.dateData];
        dates.forEach((item,ind,arr)=>arr[ind]=(item.substring(0,item.length-5)));
        let t1 = performance.now();
        return dates;
      },
      tempData(){
        let t0 = performance.now();
        // let tempHighs = [];
        let tempAvg = [];
        let precip = [];
        let solarEnergy = [];
        let windspeed = [];
        for(const day in this.dateData){
          // let oneDayData = (weatherData.filter(data => new Date(data.Time).toLocaleDateString() == this.dateData[date]));
          let hourOffset = new Date(weatherData[day*24].Time).getHours();
          let oneDayData = weatherData.slice(day*24-hourOffset,(day*1+1)*24-hourOffset);
          oneDayData = oneDayData.filter(data => this.timesSelected.includes(new Date(data.Time).getHours()));
          //tempHigh.push(Math.max(...oneDayData.map(data => data.DBTdgF)));
          tempAvg.push(oneDayData.reduce((total,arr) => total+arr.DBTdgF,0)/oneDayData.length); //average Temp
          precip.push(oneDayData.reduce((total,arr) => total+arr.Precipin,0)); //cumulative rain in day
          solarEnergy.push(oneDayData.reduce((total,arr) => total+arr.GHIkWhm2,0)); //cumulative solar energy
          windspeed.push(oneDayData.reduce((total,arr) => total+arr.WindSpeedmph,0)/oneDayData.length); //average windspeed
        }
        // console.log(precip)
        let t1 = performance.now();
        return [tempAvg,precip,solarEnergy,windspeed];
        //return this.filterData.map(data => data.DBTdgF);
      },
      refreshDataZoom: function(){
        this.onResize();
        this.dataZoom.showLoading()
        // console.log(...this.dateData.forEach(this.dayMonthData))
        let yAxisLabel = ['Degrees F','Inches','kWh/m^2','MPH'];
        // let length = [];
        // length.length = this.dateData.length;
        let dataZoomOption = {
          grid: {
            top: 10,
            bottom: 20,
          },
          xAxis: {
            type: 'category',
            data: this.dayMonthData,
            axisLabel: {
              show: false,
            },
          },
          yAxis: {
            type: 'value',
            show: true,
            scale: true,
            name: yAxisLabel[this.weatherDataOption],
            nameRotate: 90,
            nameLocation: 'center',
            nameGap: 40,
            nameTextStyle: {fontSize: 16},
          },
          dataZoom: [
            {
              name: 'dataZoom',
              type: 'slider',
              show: true,
              start: 0,
              end: 100,
              handleSize: 30,
              filterMode: 'filter',
              textStyle: {
                fontWeight: 'bold',
                fontSize: 16,
              }
            },
          ],
          series: [
            {
              name: 'dataZoom',
              type: 'line',
              data: this.tempData[this.weatherDataOption],
            }
          ]
        };
        this.dataZoom.setOption(dataZoomOption,true);
        dataZoomOption.dataZoom[0].startValue = this.$store.state.startDateInd;
        dataZoomOption.dataZoom[0].start = this.$store.state.startDateInd/this.dateData.length*100;
        dataZoomOption.dataZoom[0].endValue = this.$store.state.endDateInd;
        dataZoomOption.dataZoom[0].end = this.$store.state.endDateInd/this.dateData.length*100;
        this.dataZoom.hideLoading();
        this.dataZoom.setOption(dataZoomOption,true);
      },
    },
    beforeDestroy: function(){
        console.log('Leaving route')
        this.stopLooping();
        this.$store.commit('changeDataLoopOption');
    },
    mounted: function () {
      echarts.registerTheme('shine', shine)
      this.dataZoom = echarts.init(this.$refs.dataZoom,'shine');
      this.refreshDataZoom;
      this.dataZoom.on('dataZoom',this.changeDataZoom);
      _.debounce(this.onResize,100)();
      // this.dataLoopChange();
    }

  }
</script>
